var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ipub-col",style:({
      width: _vm.width,
      margin: _vm.margin,
      'margin-left': _vm.marginLeft
    })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }